let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("awqCy"), load("6wr18"), load("ffEVr"), load("7EorR"), load("fZt2F"), load("hhss7"), load("9IaUU")]).then(() => parcelRequire('lQ3Oi'));